import { ReactNode, useState } from "react";
import { PrintJson } from "../../../../../theme/Component/PrintJson";
import { PiBagSimple, PiFilesFill, PiFolderOpenFill, PiHouse, PiShirtFolded, PiStudent, PiUsersThree } from "react-icons/pi";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { PositionObjetive } from "../../../../../pages/DefaultHomePage/Dashed/components/ContracsDashed/ComponentContract/PositionObjetive";
import { AppointmentManualPdfDashed } from "../../../../../pages/DefaultHomePage/Dashed/components/ContracsDashed/ComponentContract/AppointmentManualPDFDashe";
import { AcademicInformation } from "../../../../../Talentohumano/GestionTH/AcademicInformation/AcademicInformation";
import { WorkExperience } from "../../../../../Talentohumano/GestionTH/WorkExperience/WorkExperience";
import { FamilyGroup } from "../../../../../Talentohumano/GestionTH/FamilyGroup/FamilyGroup";
import { BodyMeasurements } from "../../../../../Talentohumano/ParametrosTalentoHumano/BodyMeasurements/BodyMeasurements";
import { BasicDataUpdate } from "../../../../../pages/DefaultHomePage/Dashed/components/ContracsDashed/ComponentContract/BasicDataUpdate";
import "./TeamGroupMemberInfo.css"

type GroupMember = {
    IDEmployee: number
    IDContract: number
    [key: string]: any
}

type EmployeeContract = {
    IDAccount: number
    IDContract: number
    [key: string]: any
}

type PropsTeamGroupInfo =
    | { type: "groupMember"; groupMeber: GroupMember }
    | { type: "employeeContract"; groupMeber: EmployeeContract }

type QuickAction = {
    icon: ReactNode
    label: string
    event: () => void
}

export const TeamGroupMembersInfo = ({ groupMeber, type }: PropsTeamGroupInfo) => {

    const [tap, setTap] = useState<number>(0);
    const accountId = type === "groupMember" ? groupMeber.IDAccount : groupMeber.IDAccount;
    const contractId = groupMeber.IDContract;

    const certificateTabs: QuickAction[] = [
        {
            label: 'Objetivos de Desempeño',
            icon: <PiFolderOpenFill />,
            event: () => { setTap(1) }

        },
        {
            label: 'Ver Manual de Funciones y Competencias',
            icon: <PiFilesFill />,
            event: () => { setTap(2) }

        },
        {
            label: 'Información Académica',
            icon: <PiStudent />,
            event: () => { setTap(3) }

        },
        {
            label: 'Experiencia Laboral',
            icon: <PiBagSimple />,
            event: () => { setTap(4) }

        },
        {
            label: 'Grupo Familiar',
            icon: <PiUsersThree />,
            event: () => { setTap(5) }

        },
        {
            label: 'Tallaje',
            icon: <PiShirtFolded />,
            event: () => { setTap(6) }

        },
        {
            label: 'Información Basica',
            icon: <PiHouse />,
            event: () => { setTap(7) }

        },
    ]

    const renderComponent = (tapid: number) => {

        switch (tapid) {
            case 1:
                return (
                    <div className="p-3">
                        <BasicButton icon='ri-arrow-left-line' eventClick={() => setTap(0)}>Volver</BasicButton>
                        <PositionObjetive accountContrac={contractId} dashedMenu={true} />
                    </div>
                );
            case 2:
                return (
                    <div className="p-3">
                        <BasicButton icon='ri-arrow-left-line' eventClick={() => setTap(0)}>Volver</BasicButton>
                        <AppointmentManualPdfDashed IDAccount={accountId} />
                    </div>
                );
            case 3:
                return (
                    <div className="p-3">
                        <BasicButton icon='ri-arrow-left-line' eventClick={() => setTap(0)}>Volver</BasicButton>
                        <AcademicInformation IDAccount={accountId} dashedMenu />
                    </div>
                );
            case 4:
                return (
                    <div className="p-3">
                        <BasicButton icon='ri-arrow-left-line' eventClick={() => setTap(0)}>Volver</BasicButton>
                        <WorkExperience IDAccount={accountId} dashedMenu />
                    </div>
                );
            case 5:
                return (
                    <div className="p-3">
                        <BasicButton icon='ri-arrow-left-line' eventClick={() => setTap(0)}>Volver</BasicButton>
                        <FamilyGroup IDAccount={accountId} dashedMenu />
                    </div>
                );
            case 6:
                return (
                    <div className="p-3">
                        <BasicButton icon='ri-arrow-left-line' eventClick={() => setTap(0)}>Volver</BasicButton>
                        <BodyMeasurements idAccount={accountId} dashedMenu />
                    </div>
                );
            case 7:
                return (
                    <div className="p-3">
                        <BasicButton icon='ri-arrow-left-line' eventClick={() => setTap(0)}>Volver</BasicButton>
                        <BasicDataUpdate IDAccount={accountId} />
                    </div>
                );
            default:
                return (
                    <div className="row">
                        {certificateTabs.map((item, index) => {

                            const active = tap === index + 1

                            return (
                                <div className="col-md-6 p-2">
                                    <div className={`tgmi-card ${active ? "active" : ""}`} onClick={() => item.event()}>
                                        <div className="tgmi-card-label">
                                            {item.label}
                                        </div>

                                        <div className="tgmi-card-icon">
                                            {item.icon}
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                );
        }
    }

    return (
        <>
            <div className="row">
                <div className="col-md-12">
                    {renderComponent(tap)}
                </div>
            </div>
        </>
    )
}